import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from '@app/services/title.service';
import { SuccessStoryService } from '../../../services/success-story.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PageTitle, DetailsDesc, ImportantFacts, Info, Image } from './models';
import { SuccessStory } from '@app/store/stories/state';
import { CanEditService } from '@app/services/can-edit.service';

@Component({
  selector: 'app-case-studies-details-page',
  templateUrl: './case-studies-details-page.component.html',
  styleUrls: ['./case-studies-details-page.component.scss'],
})
export class CaseStudiesDetailsPageComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  stories: any;
  mainimage: any;
  coverimage: any;
  pageData = '';
  editsuccess: boolean = false;
  showbutton: boolean = false;
  id: number;

  // TODO DUPLICATED LOGIC OF FORM ... THIS SHOULD USE THE SAME FORM ADD SUCCESS STORIES
  addsuccessstoryForm: SuccessStory = {
    id: 0,
    title: '',
    short_description: '',
    solutions: '',
    cover_image: '',
    content_images: [],
    benefits_results: '',
    business_challenges: '',
    post_date: '',
    video: '',
  };

  pageTitleArea: PageTitle[] = [
    {
      title: 'Case Studies Details',
      subTitle: 'Data Science in Pharmaceutical Industries',
    },
  ];
  caseStudiesDetailsImage: Image[] = [
    {
      img: 'assets/img/projects/projects-details1.jpg',
    },
  ];
  caseStudiesDetailsDesc: DetailsDesc[] = [
    {
      subTitle: 'Data Science',
      title1:
        'Complete Data Science Training: Mathematics, Statistics, Python, Advanced Statistics in Python',
      paragraph1:
        'Improve Machine Learning algorithms by studying underfitting, overfitting, training, validation, n-fold cross validation, testing, and how hyperparameters could improve performance. Perform linear and logistic regressions in Python.',
      img1: 'assets/img/projects/img2.jpg',
      img2: '',
      title2: 'Important Facts',
      paragraph2:
        'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using ‘Content here, content here’, making it look like readable English. Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable.',
      paragraph3:
        'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don’t look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn’t anything embarrassing hidden in the middle of text.',
      title3: 'Results',
      paragraph4:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore magna ad aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco labori.',
      paragraph5: '',
      paragraph6: '',
      paragraph7: '',
      paragraph8: '',
      title4: '',
      title5: '',
      title6: '',
      title7: '',
      title8: '',
    },
  ];
  caseStudiesDetailsDescImportantFacts: ImportantFacts[] = [
    {
      title: 'The Field of Data Science',
    },
    {
      title: 'The Problem',
    },
    {
      title: 'The Solution',
    },
    {
      title: 'The Skills',
    },
    {
      title: 'Statistics',
    },
    {
      title: 'Mathematics',
    },
  ];
  caseStudiesDetailsInfo: Info[] = [
    {
      icon: 'bx bx-user-pin',
      title: 'Client',
      subTitle: 'EnvyTheme',
    },
    {
      icon: 'bx bx-map',
      title: 'Location',
      subTitle: 'New York, USA',
    },
    {
      icon: 'bx bx-purchase-tag',
      title: 'Technologies',
      subTitle: 'Python, Data Science',
    },
    {
      icon: 'bx bx-check',
      title: 'Completed',
      subTitle: '28 April 2020',
    },
    {
      icon: 'bx bx-globe',
      title: 'Website',
      subTitle: 'EnvyTheme.com',
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private titleService: TitleService,
    private successStoryService: SuccessStoryService,
    public datepipe: DatePipe,
    public canEditService: CanEditService
  ) {}

  get isHardCodedStory(): boolean {
    return ['goldtable', 'globalwells', 'iscout-kpa'].includes(
      this.route.snapshot.params.story
    );
  }

  ngOnInit(): void {
    this.route.data
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        switch (data.kind) {
          case 'data-foundation-architecture': {
            this.pageData = 'data-foundation-architecture';
            this.pageTitleArea = [
              {
                title: 'Data Foundation',
                subTitle: 'Data Architecture & Modeling ',
              },
            ];
            this.caseStudiesDetailsDesc = [
              {
                subTitle: 'Data Architecture & Modeling',
                title1: '',
                paragraph1:
                  'Data architecture describes the structure of physical data assets and data management resources, according to <a href="https://www.cio.com/article/3251707/what-is-togaf-an-enterprise-architecture-methodology-for-business.html" target="_blank">The Open Group Architecture Framework (TOGAF)</a>. It comprises the models, policies, rules, and standards that govern the collection, storage, arrangement, integration, and use of data. ',
                img1: 'assets/img/history/img1.jpg',
                img2: '',
                title2: '',
                paragraph2:
                  'The goal of data architecture is to translate business needs into data and system requirements and to manage data and its flow through the enterprise. ',
                paragraph3:
                  'Learn more about UDF Architecture & Data Modeling <a href="https://app-5de775b1eb601d.spteamapps.na.xom.com/sites/UDAO/UDF/IntranetApp/Pages/Home.aspx?SPHostUrl=https%3A%2F%2Fishareteam7%2Ena%2Exom%2Ecom%2Fsites%2FUDAO%2FUDF&SPLanguage=en%2DUS&SPClientTag=0&SPProductNumber=15%2E0%2E5207%2E1000&SPAppWebUrl=https%3A%2F%2Fapp%2D5de775b1eb601d%2Espteamapps%2Ena%2Exom%2Ecom%2Fsites%2FUDAO%2FUDF%2FIntranetApp" target="_blank"> here.</a>  ',
                title3: '',
                paragraph4: '',
                paragraph5: '',
                paragraph6: '',
                paragraph7: '',
                paragraph8: '',
                title4: '',
                title5: '',
                title6: '',
                title7: '',
                title8: '',
              },
            ];
            this.caseStudiesDetailsImage = [
              {
                img: 'assets/img/history/img1.jpg',
              },
            ];
            break;
          }
          case 'success-stories-details': {
            if (this.route.snapshot.params.story === 'globalwells') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Data Foundation',
                  subTitle: 'Data Architecture & Modeling ',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'Data Architecture & Modeling',
                  title1: '',
                  paragraph1:
                    'Data architecture describes the structure of physical data assets and data management resources, according to <a href="https://www.cio.com/article/3251707/what-is-togaf-an-enterprise-architecture-methodology-for-business.html" target="_blank">The Open Group Architecture Framework (TOGAF)</a>. It comprises the models, policies, rules, and standards that govern the collection, storage, arrangement, integration, and use of data. ',
                  img1: 'assets/img/history/img1.jpg',
                  img2: '',
                  title2: 'Existing Alternatives',
                  paragraph2:
                    '<ul><li>Inquiring each business unit annually and manually mapping well, status, and field counts in an Excel spreadsheet</li><li>Manually manage well data access in UDF  </li><li>Global EMSDB Well & Well Catalog</li></ul> ',
                  paragraph3:
                    '<ul><li>Global list of wells with well operating status, company code, ownership, and other standard well header metadata that is automatically generated and maintained</li><li>Easy curation and validation process to make well list authoritative/trusted </li><li>Updating UDF Access model to leverage global well list</li><li>Updated Well business workflows to keep data evergreen </li><li>BI Dashboard for easy ad hoc</li></ul> ',
                  title3: 'Solution',
                  paragraph4:
                    '<p><ul><li>Number of Controllers and Planners using Global Well List to report well counts</li><li>Overall time spent to generate annual 10k report</li><li>Number of errors identified in regulatory reporting</li><li>Reduction of manual access control points in UDF</li></ul></p>',
                  title4: 'Key Metrics',
                  paragraph5:
                    '<ul><li>Reduced annual data validation effort spent by controllers and business units.  Enables effort saved to be focused on higher value activities.</li><li>Decrease in risk of regulatory reporting errors</li><li>Clarity on total operated and operated by other well counts by well status</li><li>Improve governance of well contractual data use restrictions</li><li>Streamlines divestment/data isolation effort by having an authoritative list of wells for the asset</li><li>Improved data quality through process automation</li><li>Faster decision making related to planning, regulatory requirements, and analysis</li></ul>',
                  title5: 'Unique Value Proposition',
                  paragraph6:
                    '<ul><li>Authoritative global well list, access control, and supporting sustainment processes</li></ul>',
                  title6: 'High-Level Concept',
                  paragraph7:
                    '<ul><li>Implementation:<ul><li>UIS Wells / DA&O & Controllers, work effort to define process, business requirements, & any related documentation</li><li>IT spend to build/configure integration and any licensing costs</li></ul></li><li> Sustainment: (Assumption is this is small) <ul><li>Effort by UIS to sustain process health (e.g., RDC?)</li><li>Effort by Controllers & BUs to regularly validate data</li><li>Effort for IT base support</li></ul></li></ul>',
                  title7: 'Cost Structure',
                  paragraph8:
                    '<ul><li>Foundational & Strategic as part of UDF as will be reused by multiple use cases</li></ul></p>',
                  title8: 'Revenue Streams',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/Global-wells.jpg',
                },
              ];
            } else if (this.route.snapshot.params.story === 'iscout-kpa') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'PNG iScout/KPA - Preventing Equipment Failure',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'PNG iScout/KPA - Preventing Equipment Failure',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Screening through 700+ small bore connections to find potential links/areas that would be prone to fatigue failures (use case not originally contemplated as part of the iScout/KPA data to Kepler effort)</li><li>Previous efforts did not enable rapid screening of highest risk items, prolonging identification of appropriate fixes</li></ul>',
                  img1: 'assets/img/projects/iScout-KPA.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>KPA (SaaS) was leveraged to build the data collection form</li>' +
                    '<li>Operations gathered the photos and screening criteria for all of the connections</li>' +
                    '<li>UDFO/EGUL DT developed the pipeline to auto-ingest data to Kepler (Snowflake); solution delivered is dynamic, fully-automated, future-proof, and scalable</li>' +
                    '<li>PNG Ops Technical Engineering department was able connect to the data in Kepler using PowerBI, screen the connections, and identify 21 that required further inspection</li>' +
                    '<li>It was discovered that one of the initial 5 had a crack in the pipe and the field team completed repairs on the impacted section</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Rapid screening of small bore connections (time saving)</li>' +
                    '<li>Proactively addressing potential cracks, evading a possible loss of primary containment event at high pressure (eliminate potential safety hazard and cost avoidance)</li>' +
                    '<li>Use of Databricks platform significantly reduced coding efforts (FTE saving) while enabling increased integration with Snowflake and improved scalability, monitoring, and supportability</li></ul>',
                  paragraph4: '',
                  paragraph5: '',
                  paragraph6: '',
                  paragraph7: '',
                  paragraph8: '',
                  title4: '',
                  title5: '',
                  title6: '',
                  title7: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/history/img1.jpg',
                },
              ];
              break;
            } else if (this.route.snapshot.params.story === 'goldtable') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'WellView Timelog Gold Table',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'WellView Timelog Gold Table',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Objective was to quickly and easily interrogate nearly 10 million well construction records in WellView to search for specific events or technologies which have been captured as part of the text "narrative" of the operations.</li><li>Previous approach involved a time intensive and technically complex querying of conventional and unconventional WellView instances within the WellView application itself or use of SQL query tools, pulling the data into Excel for search and manipulation.</li>' +
                    '<li>Alternatively, requests to the organization for information via email or other channels could take weeks to months to complete.</li></ul>',
                  img1: 'assets/img/projects/WellView-Timelog-Gold-Table.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>Conventional and unconventional WellView databases were ingested into the Upstream Data Foundation (Kepler / MDP as appropriate)</li>' +
                    '<li>The Wells Data Foundation team (WDF) utilized Python and Databricks to develop a single view on the data which was then written back to Kepler as a "Gold Table"</li>' +
                    '<li>WDF then created a Spotfire dashboard to allow the data to be filtered and searched</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Wells users can now search the complete Timelog data for 33,000 wells that ExxonMobil drilled, operates, or has participated as a partner. This spans across our conventional and unconventional operations, which in the past had to be queried separately from their respective systems.</li>' +
                    '<li>Data is essentially available in real time, as opposed to stale and incomplete data residing in spreadsheet extracts.</li>' +
                    '<li>The Gold Table is available for others to create their own custom visualizations into the data.</li>' +
                    '<li>An early use case involved a Wells SME looking for everywhere a specific technology had been used. In under a minute, the SME was able to identify 13 wells in four countries where the technology had been employed. It is estimated that it would have taken several weeks to be able to poll the affiliates and follow up, and that would still have likely missed two wells that had been operated by others.</li></ul>',
                  title4: '',
                  paragraph4:
                    '<ul><li><a *ngIf="singleProjectsContent.title=="WellView Timelog Gold Table"" href="https://goto/GOLDTABLES" target="_blank">Want to Learn More?</a></li></ul>',
                  paragraph5: '',
                  title5: '',
                  paragraph6: '',
                  title6: '',
                  paragraph7: '',
                  title7: '',
                  paragraph8: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/WellView-Timelog-Gold-Table-Search.jpg',
                },
              ];
            } else {
              this.id = this.route.snapshot.params.story;
              this.successStoryService.getbyid(this.id).subscribe({
                next: res => {
                  const userName = this.successStoryService.userName();
                  console.log(userName);
                  if (userName.displayName == undefined) {
                    this.showbutton = false;
                  } else if (res.post_by.displayName == userName.displayName) {
                    this.showbutton = true;
                  } else if (this.canEditService.canEditTeam.includes(userName?.displayName)) {
                    this.showbutton = true;
                  } else {
                    this.showbutton = false;
                  }

                  this.coverimage = res.cover_image;
                  this.mainimage = res.main_image;
                  res.cover_image = '';
                  res.main_image = '';
                  res.post_date = res.post_date.replace(/"/g, '');
                  let currentDateTime = this.datepipe.transform(
                    res.post_date,
                    'MM-dd-yyyy'
                  );
                  res.post_date = currentDateTime;
                  res.last_modified_date = res.post_date.replace(/"/g, '');
                  let currentModifiedDate = this.datepipe.transform(
                    res.last_modified_date,
                    'MM-dd-yyyy'
                  );
                  res.last_modified_date = currentModifiedDate;
                  this.stories = res;
                  this.pageData = 'success-stories-details';
                  this.pageTitleArea = [
                    {
                      title: 'Success Stories',
                      subTitle: this.stories.title,
                    },
                  ];
                },
                error: error => {
                  console.log('error', error);
                },
              });
            }
            break;
          }
          case 'data-foundation-governance':
            {
              this.pageData = 'data-foundation-governance';
              this.pageTitleArea = [
                {
                  title: 'Data Foundation',
                  subTitle: 'Data Governance ',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'WellView Timelog Gold Table',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Objective was to quickly and easily interrogate nearly 10 million well construction records in WellView to search for specific events or technologies which have been captured as part of the text "narrative" of the operations.</li><li>Previous approach involved a time intensive and technically complex querying of conventional and unconventional WellView instances within the WellView application itself or use of SQL query tools, pulling the data into Excel for search and manipulation.</li>' +
                    '<li>Alternatively, requests to the organization for information via email or other channels could take weeks to months to complete.</li></ul>',
                  img1: 'assets/img/projects/WellView-Timelog-Gold-Table.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>Conventional and unconventional WellView databases were ingested into the Upstream Data Foundation (Kepler / MDP as appropriate)</li>' +
                    '<li>The Wells Data Foundation team (WDF) utilized Python and Databricks to develop a single view on the data which was then written back to Kepler as a "Gold Table"</li>' +
                    '<li>WDF then created a Spotfire dashboard to allow the data to be filtered and searched</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Wells users can now search the complete Timelog data for 33,000 wells that ExxonMobil drilled, operates, or has participated as a partner. This spans across our conventional and unconventional operations, which in the past had to be queried separately from their respective systems.</li>' +
                    '<li>Data is essentially available in real time, as opposed to stale and incomplete data residing in spreadsheet extracts.</li>' +
                    '<li>The Gold Table is available for others to create their own custom visualizations into the data.</li>' +
                    '<li>An early use case involved a Wells SME looking for everywhere a specific technology had been used. In under a minute, the SME was able to identify 13 wells in four countries where the technology had been employed. It is estimated that it would have taken several weeks to be able to poll the affiliates and follow up, and that would still have likely missed two wells that had been operated by others.</li></ul>',
                  paragraph4:
                    '<ul><li><a *ngIf="singleProjectsContent.title=="WellView Timelog Gold Table"" href="https://goto/GOLDTABLES" target="_blank">Want to Learn More?</a></li></ul>',
                  paragraph5: '',
                  paragraph6: '',
                  paragraph7: '',
                  paragraph8: '',
                  title4: '',
                  title5: '',
                  title6: '',
                  title7: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/history/img2.jpg',
                },
              ];
              // break;
            }
            if (this.route.snapshot.params.story === 'globalwells') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'Global Well List',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'Global Well List',
                  title1: 'Problem Statement',
                  paragraph1:
                    '<ul><li>We cannot effectively generate a global list of wells that we operate or hold an ownership interest in for regulatory reporting without manually reconciling data with all business units</li><li>We cannot easily govern well data access based on contractual data use restrictions (via company codes)</li><li>We do not have a single global mastered well data set today</li></ul>',
                  img1: 'assets/img/projects/Global-wells.jpg',
                  img2: '',
                  title2: 'Existing Alternatives',
                  paragraph2:
                    '<ul><li>Inquiring each business unit annually and manually mapping well, status, and field counts in an Excel spreadsheet</li><li>Manually manage well data access in UDF  </li><li>Global EMSDB Well & Well Catalog</li></ul> ',
                  paragraph3:
                    '<ul><li>Global list of wells with well operating status, company code, ownership, and other standard well header metadata that is automatically generated and maintained</li><li>Easy curation and validation process to make well list authoritative/trusted </li><li>Updating UDF Access model to leverage global well list</li><li>Updated Well business workflows to keep data evergreen </li><li>BI Dashboard for easy ad hoc</li></ul> ',
                  title3: 'Solution',
                  paragraph4:
                    '<p><ul><li>Number of Controllers and Planners using Global Well List to report well counts</li><li>Overall time spent to generate annual 10k report</li><li>Number of errors identified in regulatory reporting</li><li>Reduction of manual access control points in UDF</li></ul></p>',
                  title4: 'Key Metrics',
                  paragraph5:
                    '<ul><li>Reduced annual data validation effort spent by controllers and business units.  Enables effort saved to be focused on higher value activities.</li><li>Decrease in risk of regulatory reporting errors</li><li>Clarity on total operated and operated by other well counts by well status</li><li>Improve governance of well contractual data use restrictions</li><li>Streamlines divestment/data isolation effort by having an authoritative list of wells for the asset</li><li>Improved data quality through process automation</li><li>Faster decision making related to planning, regulatory requirements, and analysis</li></ul>',
                  title5: 'Unique Value Proposition',
                  paragraph6:
                    '<ul><li>Authoritative global well list, access control, and supporting sustainment processes</li></ul>',
                  title6: 'High-Level Concept',
                  paragraph7:
                    '<ul><li>Implementation:<ul><li>UIS Wells / DA&O & Controllers, work effort to define process, business requirements, & any related documentation</li><li>IT spend to build/configure integration and any licensing costs</li></ul></li><li> Sustainment: (Assumption is this is small) <ul><li>Effort by UIS to sustain process health (e.g., RDC?)</li><li>Effort by Controllers & BUs to regularly validate data</li><li>Effort for IT base support</li></ul></li></ul>',
                  title7: 'Cost Structure',
                  paragraph8:
                    '<ul><li>Foundational & Strategic as part of UDF as will be reused by multiple use cases</li></ul></p>',
                  title8: 'Revenue Streams',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/Global-wells.jpg',
                },
              ];
            } else if (this.route.snapshot.params.story === 'iscout-kpa') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'PNG iScout/KPA - Preventing Equipment Failure',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'PNG iScout/KPA - Preventing Equipment Failure',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Screening through 700+ small bore connections to find potential links/areas that would be prone to fatigue failures (use case not originally contemplated as part of the iScout/KPA data to Kepler effort)</li><li>Previous efforts did not enable rapid screening of highest risk items, prolonging identification of appropriate fixes</li></ul>',
                  img1: 'assets/img/projects/iScout-KPA.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>KPA (SaaS) was leveraged to build the data collection form</li>' +
                    '<li>Operations gathered the photos and screening criteria for all of the connections</li>' +
                    '<li>UDFO/EGUL DT developed the pipeline to auto-ingest data to Kepler (Snowflake); solution delivered is dynamic, fully-automated, future-proof, and scalable</li>' +
                    '<li>PNG Ops Technical Engineering department was able connect to the data in Kepler using PowerBI, screen the connections, and identify 21 that required further inspection</li>' +
                    '<li>It was discovered that one of the initial 5 had a crack in the pipe and the field team completed repairs on the impacted section</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Rapid screening of small bore connections (time saving)</li>' +
                    '<li>Proactively addressing potential cracks, evading a possible loss of primary containment event at high pressure (eliminate potential safety hazard and cost avoidance)</li>' +
                    '<li>Use of Databricks platform significantly reduced coding efforts (FTE saving) while enabling increased integration with Snowflake and improved scalability, monitoring, and supportability</li></ul>',
                  title4: '',
                  paragraph4: '',
                  paragraph5: '',
                  title5: '',
                  paragraph6: '',
                  title6: '',
                  paragraph7: '',
                  title7: '',
                  paragraph8: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/iScout-KPA.png',
                },
              ];
            } else if (this.route.snapshot.params.story === 'goldtable') {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'WellView Timelog Gold Table',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'WellView Timelog Gold Table',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Objective was to quickly and easily interrogate nearly 10 million well construction records in WellView to search for specific events or technologies which have been captured as part of the text "narrative" of the operations.</li><li>Previous approach involved a time intensive and technically complex querying of conventional and unconventional WellView instances within the WellView application itself or use of SQL query tools, pulling the data into Excel for search and manipulation.</li>' +
                    '<li>Alternatively, requests to the organization for information via email or other channels could take weeks to months to complete.</li></ul>',
                  img1: 'assets/img/projects/WellView-Timelog-Gold-Table.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>Conventional and unconventional WellView databases were ingested into the Upstream Data Foundation (Kepler / MDP as appropriate)</li>' +
                    '<li>The Wells Data Foundation team (WDF) utilized Python and Databricks to develop a single view on the data which was then written back to Kepler as a "Gold Table"</li>' +
                    '<li>WDF then created a Spotfire dashboard to allow the data to be filtered and searched</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Wells users can now search the complete Timelog data for 33,000 wells that ExxonMobil drilled, operates, or has participated as a partner. This spans across our conventional and unconventional operations, which in the past had to be queried separately from their respective systems.</li>' +
                    '<li>Data is essentially available in real time, as opposed to stale and incomplete data residing in spreadsheet extracts.</li>' +
                    '<li>The Gold Table is available for others to create their own custom visualizations into the data.</li>' +
                    '<li>An early use case involved a Wells SME looking for everywhere a specific technology had been used. In under a minute, the SME was able to identify 13 wells in four countries where the technology had been employed. It is estimated that it would have taken several weeks to be able to poll the affiliates and follow up, and that would still have likely missed two wells that had been operated by others.</li></ul>',
                  title4: '',
                  paragraph4:
                    '<ul><li><a *ngIf="singleProjectsContent.title=="WellView Timelog Gold Table"" href="https://goto/GOLDTABLES" target="_blank">Want to Learn More?</a></li></ul>',
                  paragraph5: '',
                  title5: '',
                  paragraph6: '',
                  title6: '',
                  paragraph7: '',
                  title7: '',
                  paragraph8: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/WellView-Timelog-Gold-Table-Search.jpg',
                },
              ];
            } else if (this.route.snapshot.params.story == 1) {
              this.pageData = 'success-stories-details';
              this.pageTitleArea = [
                {
                  title: 'Success Stories',
                  subTitle: 'WellView Timelog Gold Table',
                },
              ];
              this.caseStudiesDetailsDesc = [
                {
                  subTitle: 'WellView Timelog Gold Table',
                  title1: 'Business Challenge',
                  paragraph1:
                    '<ul><li>Objective was to quickly and easily interrogate nearly 10 million well construction records in WellView to search for specific events or technologies which have been captured as part of the text "narrative" of the operations.</li><li>Previous approach involved a time intensive and technically complex querying of conventional and unconventional WellView instances within the WellView application itself or use of SQL query tools, pulling the data into Excel for search and manipulation.</li>' +
                    '<li>Alternatively, requests to the organization for information via email or other channels could take weeks to months to complete.</li></ul>',
                  img1: 'assets/img/projects/WellView-Timelog-Gold-Table.png',
                  img2: '',
                  title2: 'Solution',
                  paragraph2:
                    '<ul><li>Conventional and unconventional WellView databases were ingested into the Upstream Data Foundation (Kepler / MDP as appropriate)</li>' +
                    '<li>The Wells Data Foundation team (WDF) utilized Python and Databricks to develop a single view on the data which was then written back to Kepler as a "Gold Table"</li>' +
                    '<li>WDF then created a Spotfire dashboard to allow the data to be filtered and searched</li></ul>',
                  title3: 'Benefits & Results',
                  paragraph3:
                    '<ul><li>Wells users can now search the complete Timelog data for 33,000 wells that ExxonMobil drilled, operates, or has participated as a partner. This spans across our conventional and unconventional operations, which in the past had to be queried separately from their respective systems.</li>' +
                    '<li>Data is essentially available in real time, as opposed to stale and incomplete data residing in spreadsheet extracts.</li>' +
                    '<li>The Gold Table is available for others to create their own custom visualizations into the data.</li>' +
                    '<li>An early use case involved a Wells SME looking for everywhere a specific technology had been used. In under a minute, the SME was able to identify 13 wells in four countries where the technology had been employed. It is estimated that it would have taken several weeks to be able to poll the affiliates and follow up, and that would still have likely missed two wells that had been operated by others.</li></ul>',
                  title4: '',
                  paragraph4:
                    '<ul><li><a *ngIf="singleProjectsContent.title=="WellView Timelog Gold Table"" href="https://goto/GOLDTABLES" target="_blank">Want to Learn More?</a></li></ul>',
                  paragraph5: '',
                  title5: '',
                  paragraph6: '',
                  title6: '',
                  paragraph7: '',
                  title7: '',
                  paragraph8: '',
                  title8: '',
                },
              ];
              this.caseStudiesDetailsImage = [
                {
                  img: 'assets/img/projects/WellView-Timelog-Gold-Table-Search.jpg',
                },
              ];
            }
            break;
        }
      });

    this.titleService.setTitle('Data Foundation');
  }
}
